import { render, staticRenderFns } from "./addShoppingList.vue?vue&type=template&id=1a298cc4&"
import script from "./addShoppingList.vue?vue&type=script&lang=js&"
export * from "./addShoppingList.vue?vue&type=script&lang=js&"
import style0 from "./addShoppingList.vue?vue&type=style&index=0&id=1a298cc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports